import { BorrowerOnboardingDetails } from '@nemuru-eng/js-api-client';

import { MainResidenceEditDialog } from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/MainResidence/components/MainResidenceEditDialog';
import { MainResidenceForm } from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/MainResidence/components/MainResidenceForm';
import { useUpdateBorrowerData } from '@/components/modules/KYC/KYCLoan/BorrowerKYC/hooks/useUpdateBorrowerContract';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { PendingDataType } from '@/config/types';

interface MainResidenceProps {
  loanId: string;
  onboardingDetails: BorrowerOnboardingDetails;
  editModeAllowed?: boolean;
}

export const MainResidence = ({ loanId, onboardingDetails, editModeAllowed = false }: MainResidenceProps) => {
  const { opened, toggleDialog, setOpened } = useDialog();

  const { loan, updateBorrowerContract, requestLoading } = useUpdateBorrowerData({
    loanId,
    onboardingDetails,
  });

  const mainResidenceDetails =
    'userDetails' in onboardingDetails && onboardingDetails?.userDetails?.mainResidenceDetails;
  const toggleEditModeDialog = editModeAllowed && mainResidenceDetails ? toggleDialog : undefined;

  return (
    <SubSectionWrapper title={'MAIN_RESIDENCE'} toggleEditModeDialog={toggleEditModeDialog}>
      {loan && mainResidenceDetails ? (
        <>
          <MainResidenceForm mainResidenceDetails={mainResidenceDetails} fullWidth={false} />
          {opened && (
            <MainResidenceEditDialog
              currentLoan={loan}
              mainResidenceDetails={mainResidenceDetails}
              opened={opened}
              setOpened={setOpened}
              toggleDialog={toggleDialog}
              updateBorrowerContract={updateBorrowerContract}
              loading={requestLoading}
            />
          )}
        </>
      ) : (
        <PendingDataWarning type={PendingDataType.BORROWER_ONBOARDING} />
      )}
    </SubSectionWrapper>
  );
};
